import styled from 'styled-components';

/**
 * 「帮助中心」、「资料库」、「场景案例」使用的卡片样式
 */
export const PcCardItem = styled.div<{ width: number; height: number }>`
  width: ${props => props.width}px;
  height: ${props => props.height}px;
  border-radius: 4px;
  background-color: var(--white);
  margin: 0 var(--margin-lg) var(--margin-lg) 0;
  transition: all 0.3s;
  &:nth-child(3n) {
    margin-right: 0px;
  }
  &:hover {
    transition: all 0.3s;
    cursor: pointer;
    box-shadow: 0px 10px 22px 0px rgba(0, 0, 0, 0.12);
  }
`;

export const TagItem = styled.span`
  display: inline-block;
  font-size: 13px;
  line-height: 18px;
  border: 1px solid var(--tag-color);
  margin-right: var(--margin-sm);
  padding: 2px 6px;
  border-radius: 2px;
  &:last-child {
    margin-right: 0px;
  }
`;
